import { render, staticRenderFns } from "./TabTitle.vue?vue&type=template&id=82ad5f6c&scoped=true"
import script from "./TabTitle.vue?vue&type=script&lang=js"
export * from "./TabTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ad5f6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82ad5f6c')) {
      api.createRecord('82ad5f6c', component.options)
    } else {
      api.reload('82ad5f6c', component.options)
    }
    module.hot.accept("./TabTitle.vue?vue&type=template&id=82ad5f6c&scoped=true", function () {
      api.rerender('82ad5f6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/atoms/TabTitle.vue"
export default component.exports